import { get, map } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { SenaryParagraphHeading } from 'components/Headings';
import Image from 'components/ImageV2';
import { SubBold } from 'components/Sub';
import { IMAGE_WIDTHS } from 'constants/images';
import { TYPES } from 'constants/topNavigation';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const FeaturedCollections = ({ featuredCollections, trackNavigation, trackNavigationClick }) => {
  const handleClick = featuredCollection => {
    trackNavigation(get(featuredCollection, 'linkUrl'));
    trackNavigationClick({
      navigationType: TYPES.LEVEL_2,
      navigationLevel1: get(featuredCollection, 'linkUrl'),
      navigationLevel2: get(featuredCollection, 'label'),
      navigationSource: window.location.href,
    });
  };

  return (
    <div className="FeaturedCollections">
      <SenaryParagraphHeading className="FeaturedCollections__header">
        {I18n.localize('nav.collections')}
      </SenaryParagraphHeading>
      <ul className="FeaturedCollections__list">
        {map(featuredCollections, featuredCollection => (
          <li
            className="FeaturedCollection__item"
            key={`${get(featuredCollection, 'label')}--mobile`}
          >
            <a
              className="FeaturedCollection__link"
              href={get(featuredCollection, 'linkUrl')}
              onClick={() => handleClick(featuredCollection)}
            >
              <Image
                className="FeaturedCollection__image"
                src={get(featuredCollection, ['mobileImage', 'src'])}
                alt={get(featuredCollection, ['mobileImage', 'alt'])}
                width={IMAGE_WIDTHS.W_600}
                ratio="100:137"
              />
            </a>
            <SubBold className="FeaturedCollection__name">
              {get(featuredCollection, 'label')}
            </SubBold>
          </li>
        ))}
      </ul>
      <style jsx>{`
        .FeaturedCollections {
          display: flex;
          flex-direction: column;
        }

        .FeaturedCollections__list {
          display: flex;
          text-align: center;
        }

        .FeaturedCollection__item {
          flex: 1;
          border-right: ${Theme.get('spacing') / 2}px solid ${Theme.get('colors-white')};
        }

        .FeaturedCollection__item:last-child {
          border-right: none;
        }
      `}</style>
      <style jsx global>{`
        .FeaturedCollection__link {
          flex: 1;
          display: block;
          width: 100%;
        }

        .FeaturedCollections__header.typography--senary-heading {
          padding: ${Theme.get('spacing') * 3}px ${Theme.get('spacing') * 6}px;
        }

        .FeaturedCollection__name.Sub {
          margin-top: ${Theme.get('spacing')}px;
        }
      `}</style>
    </div>
  );
};

const FeaturedCollectionPropType = () =>
  PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      mobileImage: PropTypes.shape({
        src: PropTypes.string.isRequired,
        alt: PropTypes.string.isRequired,
      }),
      desktopImage: PropTypes.shape({
        src: PropTypes.string.isRequired,
        alt: PropTypes.string.isRequired,
      }),
      linkUrl: PropTypes.string.isRequired,
    })
  );

FeaturedCollections.propTypes = {
  featuredCollections: FeaturedCollectionPropType().isRequired,
  trackNavigation: PropTypes.func.isRequired,
  trackNavigationClick: PropTypes.func.isRequired,
};

export default FeaturedCollections;
